export const permissionUrl = {
  bankAdd: '/bank/add',
  bankDelete: '/bank/delete',
  bankModify: '/bankinfo/modify',
  bankSearch: '/bankinfo/search',
  emergencySearch: '/security/search',
  emergencyView: '/security/view',
  emergencyQuick: '/security/quick',
  emergencyDownload: '/security/download',
  emergencyDetailConfirm: '/security/detail/confirm',
  emergencyDetailModify: '/security/detail/modify',
  emergencyDetailDownload: '/security/detail/download',
  strategyOrgList: '/alarm-strategy/org-config/list',
  cameraAdd: '/camera/index/add',
  cameraBatchAdd: '/camera/index/batch-add',
  cameraDelete: '/camera/index/delete',
  cameraModify: '/camera/index/modify',
  cameraSearch: '/camera/index/search',
  aiServerAdd: '/ai-server/index/add',
  aiServerActive: '/ai-server/index/active',
  aiServerDelete: '/ai-server/index/delete',
  aiServerModify: '/ai-server/index/modify',
  aiServerSearch: '/ai-server/index/search',
  voiceDetail: '/voice-analysis/detail',
};
